const CreditScoreModelNames = {
  VantageScore: "VantageScore 4.0",
  FicoClassic: "FICO Classic",
  Fico10T: "FICO Score 10T"
};
const CreditScoreModelScoreFields = {
  [CreditScoreModelNames.VantageScore]: "vantageScore",
  [CreditScoreModelNames.FicoClassic]: "ficoClassicScore",
  [CreditScoreModelNames.Fico10T]: "fico10TScore"
};
const knownCreditScoreModels = Object.values(CreditScoreModelNames);
const parseEnabledCreditScoreModels = (setting) => {
  if (typeof setting !== "string") return [];
  const requested = setting.split(",").map((model) => model.trim().toLowerCase()).filter(Boolean);
  return knownCreditScoreModels.filter(
    (model) => requested.includes(model.toLowerCase())
  );
};
const getEnabledCreditScoreModels = (companySettings) => companySettings ? parseEnabledCreditScoreModels(companySettings.enabledCreditScoreModels) : [...knownCreditScoreModels];
export {
  CreditScoreModelNames,
  CreditScoreModelScoreFields,
  getEnabledCreditScoreModels,
  parseEnabledCreditScoreModels
};
